import {Code} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const ApiIcon = createLucideIcon(Code, 'ApiIcon');
